<script lang="ts">
  import PodcastPostCard from "$lib/molecules/newsroom/cards/PodcastPostCard.svelte";

  import { Swiper, SwiperSlide } from "swiper/svelte";
  import { Mousewheel } from "swiper";

  // import { Mousewheel } from 'swiper/modules';

  import "swiper/css";
  import Button from "$lib/atoms/Button.svelte";
  import { ButtonColor, IconType } from "$types/atoms";
  import { tick } from "svelte";

  export let posts: any;

  let slider;
  $: isBeginning = true;
  $: isEnd = false;

  function swiperReady(e) {
    slider = e.detail[0];
  }

  function slidePrev() {
    slider.slidePrev();
  }

  function slideNext() {
    slider.slideNext();
  }
</script>

{#if posts}
  <div class="max-w-[100vw] overflow-visible">
    <Swiper
      on:swiper={swiperReady}
      on:progress={async (e) => {
        isBeginning = slider?.isBeginning;
        isEnd = slider?.isEnd;
      }}
      navigation
      breakpoints={{
        0: {
          slidesPerView: 1.15,
        },
        600: {
          slidesPerView: 2.15,
        },
        1024: {
          slidesPerView: 3.15,
        },
      }}
      modules={[Mousewheel]}
      mousewheel={{
        releaseOnEdges: true,
        forceToAxis: true,
      }}
      spaceBetween={24}
      slidesPerView={3}
      preventClicks={false}
      preventClicksPropagation={false}
      shortSwipes={false}
      longSwipesRatio={0.2}
      longSwipesMs={20}
      class="!overflow-visible"
    >
      {#each posts as post}
        <SwiperSlide><PodcastPostCard {post} /></SwiperSlide>
      {/each}
    </Swiper>

    <div
      class="flex gap-2.5 justify-end mt-[35px] sm:absolute top-0 right-0 sm:mt-[0] md:mt-[5px] lg:mt-[8px]"
    >
      <div
        class="transition-opacity duration-150"
        style={`${isBeginning ? "opacity:0.3;pointer-events:none;" : ""}`}
      >
        <Button
          icon={IconType.ARROW_LEFT_LARGE}
          color={ButtonColor.GRAY}
          reduced
          on:click={slidePrev}
          iconLeft={false}
        />
      </div>
      <div
        class="transition-opacity duration-150"
        style={`${isEnd ? "opacity:0.3;pointer-events:none;" : ""}`}
      >
        <Button
          icon={IconType.ARROW_RIGHT_LARGE}
          color={ButtonColor.GRAY}
          reduced
          on:click={slideNext}
        />
      </div>
    </div>
  </div>
{/if}
